import { render, staticRenderFns } from "./warehouseLogistics.vue?vue&type=template&id=33260505&scoped=true"
import script from "./warehouseLogistics.vue?vue&type=script&lang=js"
export * from "./warehouseLogistics.vue?vue&type=script&lang=js"
import style0 from "./warehouseLogistics.vue?vue&type=style&index=0&id=33260505&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33260505",
  null
  
)

export default component.exports